import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2 } from "@angular/core";

import { PASS_TYPE, TEXT_TYPE } from "./toggle-password.const";

@Directive({
	selector: "[obgTogglePasswordFor]",
})
export class TogglePasswordDirective implements OnChanges {
	/**
	 * Text input element to hide/show text in
	 */
	@Input() obgTogglePasswordFor: HTMLInputElement | undefined;
	/**
	 * class name to set for target when input state is `password`
	 */
	@Input() passClass: string | undefined;
	/**
	 * class name to set for target when input state is `text`
	 */
	@Input() textClass: string | undefined;

	constructor(
		private renderer: Renderer2,
		private element: ElementRef
	) {}

	ngOnChanges() {
		if (!this.obgTogglePasswordFor) {
			throw new Error("Should provide target");
		}

		if (this.obgTogglePasswordFor.type === PASS_TYPE) {
			this.toggleMode(this.textClass, this.passClass);
		} else {
			this.toggleMode(this.passClass, this.textClass);
		}
	}

	@HostListener("click")
	click() {
		if (this.obgTogglePasswordFor!.type === TEXT_TYPE) {
			this.obgTogglePasswordFor!.type = PASS_TYPE;
			this.toggleMode(this.textClass, this.passClass);
		} else {
			this.obgTogglePasswordFor!.type = TEXT_TYPE;
			this.toggleMode(this.passClass, this.textClass);
		}

		// in some browsers, like FF, changing input type causes cursor to go to the very beginning.
		this.updateCursorPosition();
	}

	private updateCursorPosition() {
		const elem = this.obgTogglePasswordFor!;
		const pos = (elem.value || "").length;
		if (elem.setSelectionRange) {
			elem.setSelectionRange(pos, pos);
		}
	}

	private toggleMode(fromClass: string | undefined, toClass: string | undefined) {
		if (!toClass) {
			return;
		}

		this.renderer.addClass(this.element.nativeElement, toClass);
		if (fromClass) {
			this.renderer.removeClass(this.element.nativeElement, fromClass);
		}
	}
}
